import CarouselBannerBase from './CarouselBannerBase';
function CarouselBanner_1_4_2_full({item }) {
  
  return(
    <CarouselBannerBase item={item} imageWidth={100} aspectRatio={14/20} activeBigger={false} isCentered={false} ></CarouselBannerBase>
  )
}

export default CarouselBanner_1_4_2_full;